<div class="teacher-game-setup-overlay-header">
  <div class="teacher-game-setup-overlay-header__label">{{label}}</div>

  <div class="teacher-game-setup-overlay-header__page">{{currentStep | leadingZero:2}} / {{totalSteps | leadingZero:2}}</div>
</div>
